
export class ReqGenerateCryptoKeys {
  id: string [];
  logUser: string;
}
